import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'accountMaskPipe',
})
export class AccountMaskPipe implements PipeTransform {
    transform(value: any): any {
        // '4545454' converts to 454545-4
        if (!value) return '';
        const accountNumbers = value.slice(0, -1);
        return accountNumbers + '-' + value.at(-1);
    }
}
